import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $('.dropdown-menu__link--delete-spec-sheet').on('click', function (e) {
    const { deleteUrl } = $(e.target).data();
    $('.modal--delete-spec-sheet-confirmation').modal();
    $('.modal--delete-spec-sheet-confirmation .d-button--confirm-delete').attr('href', deleteUrl);

    return false;
  });
  $('.dropdown-menu__link--download-spec-sheet').on('click', function (e) {
    const { specSheetUrl } = $(e.target).data();
    $('.modal--spec-sheet-generate-pdf').modal();
    $('.spec-sheet-form').attr('action', specSheetUrl);

    return false;
  });

  $('.p-button--generate-spec-sheet').on('click', () => {
    $.modal.close();
  });
});
